
import "./quality-control.css";
import production from "../images/production-1.png"



const Production = () => {
    return (
        <>

            <div className="qc-container">
                <h1 className="qc-title">PRODUCTION</h1>

                <p className="qc-subtitle">FULLY IN-HOUSE LUBRICANTS & FLUIDS PRODUCTION</p>

                <div className="qc-image-wrapper">
                    <img
                        src={production}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                <div className="qc-content ">
                    <p>


                        All the lubricants are produced in-house.
                    </p>

                    
                </div>
            </div>
            
        </>



    );
};

export default Production;